module.exports = __webpack_public_path__ + "static/media/WorkInProgressImage.80e1def0.svg";